var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"third-step-component"},[(_vm.isNewOrderPage)?[(_vm.showResultWindow)?_c('result-window'):_c('payment-window')]:_c('edit-payment-window')],2)}
var staticRenderFns = []

export { render, staticRenderFns }